import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Link, useHistory, useParams } from "react-router-dom";

//UI
import { Form, Divider, Header, Loader, Button, Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

//Actions
import { createFlight } from "../../../redux/actions/catalogs/flight/createFlight";
import { initialStateFlight } from "../../../redux/actions/catalogs/flight/fetchFlight";
import { updateFlight } from "../../../redux/actions/catalogs/flight/updateFlight";
import { fetchFlightFormCustom, initialStateFlightFormCustom } from "../../../redux/slices/custom/catalogs/flight/customFlightForm.slice";

// Resources
import { scrollToTop } from "../../resources/utils";
import { typeRoutes } from "../../resources/optionsList";

export default function FlightForm() {
  const { t } = useTranslation();
  let history = useHistory();
  let { flight_id } = useParams();
  const { register, handleSubmit, errors } = useForm();
  const flightStateCustom = useSelector((state) => state.customFlightForm);
  const flightState = useSelector((state) => state.flightReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchFlightFormCustom(flight_id));
    scrollToTop();
    return () => {
      dispatch(initialStateFlight());
      dispatch(initialStateFlightFormCustom());
    };
  }, [dispatch, flight_id]);


  if (flightState.fetching || flightStateCustom.fetching) {
    return <Loader active inline />;
  }

  const onSubmit = (data) => {
    if (flight_id) {
      dispatch(updateFlight(flight_id, data));
    } else {
      dispatch(createFlight(data));
    }
  };

  if (flightState.message === "resource created successfully" || flightState.message === "resource updated successfully") {
    history.push("/flights");
  }

  return (
    <>
      {flightState.error ? (
        <Message negative content={t(flightState.error)} />
      ) : (
        ""
      )}
      <Header as='h3' dividing>{t("flight_title")}</Header>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group widths="equal">
          <Form.Field required>
            <label>{t("flight_code")}</label>
            <input name="code" defaultValue={flightStateCustom.flight.code} placeholder={t("flight_code")} autoFocus maxLength={50} ref={register({ required: true })} />
            {errors.code && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
          <Form.Field required>
            <label>{t("flight_airline")}</label>
            <select name="airline_id" defaultValue={flightStateCustom.flight.airline_id} aria-expanded="true" ref={register({ required: true })}>
              <option></option>
              {flightStateCustom.airlines.map((airline) => (
                <option key={airline.id} value={airline.id}>{airline.name}</option>
              ))}
            </select>
            {errors.airline_id && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field required>
            <label>{t("type")}</label>
            <select name="type" defaultValue={flightStateCustom.flight.type} aria-expanded="true" ref={register({ required: true })}>
              <option></option>
              {typeRoutes.map((type, index) => (
                <option key={index} value={type}>{t(type)}</option>
              ))}
            </select>
            {errors.type && (<span className="error_message">{t("required_information")}</span>
            )}
          </Form.Field>
          <Form.Field>
            <label>{t("active_tag")}</label>
            <div className="ui checkbox">
              <input type="checkbox" name="active" defaultChecked={flightStateCustom.flight.active === 1} ref={register} />
              <label></label>
            </div>
          </Form.Field>
        </Form.Group>

        <Divider variant="middle" />

        <Button primary type="submit" loading={flightStateCustom.processing ? true : false}>{t("save_button")}</Button>
        <Link to={"/flights"}><Button>{t("canceled_button")}</Button></Link>
      </Form>
    </>
  );
}
